import { useRouter, usePathname, useSearchParams } from 'next/navigation'

interface GoToPageProps {
  newPageNo: number
  searchParam?: string
  searchValue?: string
}

export function usePageNumberUpdator() {
  const router = useRouter()
  const pathname = usePathname()
  const searchParams = useSearchParams()

  const goToPage = ({ newPageNo, searchParam, searchValue }: GoToPageProps) => {
    const pathSegments = pathname.split('/')

    const lastSegment = pathSegments[pathSegments.length - 1]
    const isLastSegmentPage = !isNaN(Number(lastSegment))

    if (isLastSegmentPage) {
      pathSegments[pathSegments.length - 1] = newPageNo.toString()
    }
    const updatedPath = pathSegments.join('/')

    const params = new URLSearchParams(searchParams.toString())

    if (searchParam && searchValue) {
      params.set(searchParam, searchValue)
    }

    const queryString = params.toString()
    const url = queryString ? `${updatedPath}?${queryString}` : updatedPath

    router.push(url, { scroll: false })
  }

  return goToPage
}
